import React from 'react'
import './style.css'
import Button from '../../CtaButton'
import AuraButtonGreen from '../AuraButton/AuraButtonGreen'

const AuraCTASection = () => {
    return (
        <>
            <section className="aura-cta-section">
                <div className="container">
                    <div className="row align-items-center">
                        {/* Left Side Content (Text) */}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <h2 className="aura-cta-heading">Experience a smarter, faster, paperless clinical workflow.</h2>
                            <p className="description-text-white mb-4">Aura Clinic brings together digital onboarding, automated workflows, secure patient records, and AI-assisted tools all in one clean and intuitive platform. Discover how your clinic can reduce admin time, cut paperwork to zero, and elevate the patient experience from the very first touchpoint.</p>

                            <AuraButtonGreen text='Get a Live Demo' link='#' />
                        </div>
                        {/* Right Side Content (Image or Dashboard UI) */}
                        <div className="col-xl-6 col-lg-6 col-md-12">
                            <div className="aura-cta-dashboard-image">
                                <img src="/images/aura-clinic-icons/aura-cta-dashboard.png" alt="Dashboard Screenshot" className="img-fluid aura-cta-img" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AuraCTASection